import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { Skeleton } from 'antd';
import { FC, useRef } from 'react';
import { MediumIndicatorStatisticsRes } from '@/api/energyMedium';
import { isNil } from 'lodash-es';
import { StatisticsPartition } from './DateSwitch';
import dayjs from 'dayjs';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';

export interface ChartProps {
  loading?: boolean;
  chartData?: MediumIndicatorStatisticsRes | null;
  option?: any;
  height?: number;
}

const Charts: FC<ChartProps> = props => {
  const { option, chartData, height } = props;
  const theme = useTheme();
  const filteredChartData = chartData?.data?.filter(i => !!i);
  const chartRef = useRef<EchartsWithThemeRef>();

  return (
    <>
      <Skeleton style={{ padding: '120px 80px' }} loading={props.loading} paragraph={{ rows: 6 }}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !(filteredChartData && filteredChartData.length),
            emptyNode: <Empty />,
          }}
          option={option}
          style={{ height: height ?? 'calc(100% - 26px)' }}
          theme={theme}
          ref={d => {
            if (d) {
              chartRef.current = d;
            }
          }}
        />
      </Skeleton>
    </>
  );
};

export default Charts;

export const getTimeAxis = (aggrby: StatisticsPartition, time: number) => {
  switch (aggrby) {
    case StatisticsPartition.MINUTE_1:
    case StatisticsPartition.MINUTE_15:
    case StatisticsPartition.HOUR:
      return dayjs(time).format('YYYY-MM-DD HH:mm');
    case StatisticsPartition.DAY:
      return dayjs(time).format('YYYY-MM-DD');
    case StatisticsPartition.MONTH:
      return dayjs(time).format('YYYY-MM');
    case StatisticsPartition.YEAR:
      return dayjs(time).format('YYYY');
    default:
      return '--';
  }
};
